"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRightDistance = exports.getLeftDistance = exports.getRingIdFromPeerDescriptor = exports.getRingIdRawFromPeerDescriptor = exports.getRingIdFromRaw = exports.RING_SIZE = void 0;
exports.RING_SIZE = 2 ** 120 - 1; // 2^120 - 1
const binaryToBigInt = (binary) => {
    return binary.reduce((acc, val) => (acc << BigInt(8)) | BigInt(val), BigInt(0));
};
const getRingIdFromRaw = (raw) => Number(binaryToBigInt(raw));
exports.getRingIdFromRaw = getRingIdFromRaw;
const getRingIdRawFromPeerDescriptor = (peerDescriptor) => {
    const regionAsBuffer = Buffer.alloc(4);
    regionAsBuffer.writeUInt32BE(peerDescriptor.region ?? 0, 0);
    const ipAsbuffer = Buffer.alloc(4);
    ipAsbuffer.writeUInt32BE(peerDescriptor.ipAddress ?? 0, 0);
    const uniquePartAsBuffer = Buffer.from(peerDescriptor.nodeId.subarray(peerDescriptor.nodeId.length - 7, peerDescriptor.nodeId.length));
    const arr = [
        regionAsBuffer,
        ipAsbuffer,
        uniquePartAsBuffer
    ];
    const buffer = Buffer.concat(arr);
    return new Uint8Array(buffer);
};
exports.getRingIdRawFromPeerDescriptor = getRingIdRawFromPeerDescriptor;
const getRingIdFromPeerDescriptor = (peerDescriptor) => {
    const raw = (0, exports.getRingIdRawFromPeerDescriptor)(peerDescriptor);
    return Number(binaryToBigInt(raw));
};
exports.getRingIdFromPeerDescriptor = getRingIdFromPeerDescriptor;
const getLeftDistance = (referenceId, id) => {
    const diff = Math.abs(referenceId - id);
    if (referenceId > id) {
        // if id is smaller than referenceId, then the distance is the difference
        return diff;
    }
    else {
        // if id is bigger than referenceId, then the distance is the ringSize - difference
        return exports.RING_SIZE - diff;
    }
};
exports.getLeftDistance = getLeftDistance;
const getRightDistance = (referenceId, id) => {
    const diff = Math.abs(referenceId - id);
    if (referenceId > id) {
        // if id is smaller than referenceId, then the distance is the ringSize - difference
        return exports.RING_SIZE - diff;
    }
    else {
        // if id is bigger than referenceId, then the distance is the difference
        return diff;
    }
};
exports.getRightDistance = getRightDistance;
//# sourceMappingURL=ringIdentifiers.js.map